/* eslint-disable react-hooks/exhaustive-deps */
import { IMenuItem } from "@common/models/CMS";
import { IAppState } from "@misc/State";
import { FC, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import HeaderAccountSection from "./HeaderAccountSection";
import HeaderMenuSection from "./HeaderMenuSection";

export enum HeaderMode { Transparent, Mobile, Default }

interface IHeader {
    menuItem: IMenuItem;
    scrollUpExceptionURLs?: string[];
}

let urlPathName: string;
let isTransparent: boolean;
let lastScrollTop = 0;
const Header: FC<IHeader> = ({ menuItem, scrollUpExceptionURLs }) => {
    const headerRef = useRef<HTMLHeadElement>(null);
    const { headerStyle, banners } = useSelector((state: IAppState) => ({
        banners: state.banners,
        headerStyle: state.headerStyle
    }));
    const [marginTop, setMarginTop] = useState<number>(0);
    const { pathname } = useLocation();

    const scrollWindow = () => {
        if (!document.documentElement.classList.contains("overflow-hidden")) {
            const scroll = window.pageYOffset || window.scrollY;
            if (scroll >= lastScrollTop && scroll !== 0) {
                // downscroll
                if (scroll > 100)
                    headerRef.current?.classList.add(`hide`);
                if (scroll > marginTop)
                    setMarginTop(0);
            }
            else {
                // upscroll
                if (scrollUpExceptionURLs?.includes(urlPathName)) {
                    if (scroll === 0) {
                        headerRef.current?.classList.remove(`hide`);
                        headerRef.current?.classList.remove('transparent');
                        setMarginTop(document.getElementById('topSideBanner')?.getBoundingClientRect().height || 0)
                    }
                }
                else {
                    headerRef.current?.classList.remove(`hide`);
                    if (isTransparent && scroll === 0 && !document.querySelector(".show-menu-item"))
                        headerRef.current?.classList.add('transparent');
                    else
                        headerRef.current?.classList.remove('transparent');
                    if (scroll === 0)
                        setMarginTop(document.getElementById('topSideBanner')?.getBoundingClientRect().height || 0)
                }
            }
            lastScrollTop = scroll <= 0 ? 0 : scroll; // For Mobile or negative scrolling
        }
    }

    useEffect(() => {
        headerRef.current?.classList.remove(`hide`);
        urlPathName = pathname;
        isTransparent = headerStyle.menuStyle === "Transparent" ? true : false;
        setTimeout(() => {
            scrollWindow();
        }, 100)
    }, [pathname, headerStyle])

    useEffect(() => {
        const bannerRef = document.getElementById('topSideBanner');
        if (banners.filter(x => x.type === "topside") && bannerRef)
            setMarginTop(bannerRef.getBoundingClientRect().height);
        else
            setMarginTop(0)
    }, [banners])

    useEffect(() => {
        document.addEventListener("scroll", scrollWindow);
        return () => document.removeEventListener("scroll", scrollWindow);
    }, []);

    return (
        <header
            id="header"
            ref={headerRef}
            style={{ marginTop: `${marginTop || 0}px` }}
            className={`header ${headerStyle.menuStyle === "Blur" ? headerStyle.menuStyle.toLowerCase() : ""} ${headerStyle.menuColor.toLowerCase()}-color`}
        >
            <main className="header-container">
                <div className="container flex flex-center">
                    <HeaderMenuSection menuItem={menuItem} />
                    <HeaderAccountSection headerRef={headerRef} />
                </div>
            </main>
        </header >
    )
}

export default Header;